var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExitIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "20.000000pt",
    height: "20.000000pt",
    viewBox: "0 0 20.000000 20.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,20.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 154 c-12 -31 -6 -102 10 -118 16 -16 59 -21 88 -10 29 11 16 19 -31 19 l-48 0 0 55 0 55 48 0 c26 0 47 3 47 8 0 4 -24 7 -54 7 -40 0 -55 -4 -60 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135 120 c4 -6 -8 -10 -29 -10 -20 0 -36 -4 -36 -10 0 -5 16 -10 36 -10 21 0 33 -4 29 -10 -10 -16 11 -12 25 5 10 12 10 18 0 30 -14 17 -35 21 -25 5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitIcon);
export default __webpack_public_path__ + "static/media/exit-icon.a23659efdce4e8ba9e2e1c1d6a901632.svg";
export { ForwardRef as ReactComponent };